export default "__VITE_ASSET__DsJJCyTa__"